<style scoped>
.take-input {
  width: 40px;
}
</style>

<template>
  <mu-row class="component-wrapper">
    <mu-col span="12" sm="12" md="12" lg="4" xl="4">
      <chart :option="line" id="UserRealtime"></chart>
    </mu-col>
    <mu-col span="12" sm="12" md="12" lg="8" xl="8">
      <mu-data-table :columns="columns" stripe :data="users.slice((currentPage - 1) * itemsPerPage, (currentPage - 1) * itemsPerPage + itemsPerPage)" :no-data-text="$t('toast.load')">
        <template slot-scope="scope">
          <td>{{scope.row.name}}({{scope.row.username}}) <br/> {{scope.row.email}}</td>
          <td>{{stringRole(scope.row.roles)}}</td>
          <td><a target="_blank" :href="scope.row.route">{{scope.row.route}}</a></td>
          <td>{{scope.row.browser.os}} <br/> {{scope.row.browser.name}} ({{scope.row.browser.version}})</td>
        </template>
      </mu-data-table>
      <mu-flex justify-content="center">
        <mu-pagination :total="users.length" :current.sync="currentPage" :page-size="itemsPerPage"></mu-pagination>
      </mu-flex>
    </mu-col>
    <mu-col span="12">
      <mu-flex justify-content="end">
        <mu-text-field v-model="take" type="number" class="take-input" max="100" min="1"></mu-text-field>
      </mu-flex>
      <mu-data-table :columns="apisColumns" stripe :data="apis" :no-data-text="$t('toast.load')" :loading="loading">
        <template slot="expand" slot-scope="scope">
          <div>
            <h5>{{$t('pass.details')}}</h5>
            <pre>{{scope.row.details}}</pre>
          </div>
        </template>
        <template slot-scope="scope">
          <td>{{timestampToString(scope.row.time)}}</td>
          <td>{{scope.row.user.name}}({{scope.row.user.username}})</td>
          <td>{{scope.row.details.methods[0]}}</td>
          <td>{{scope.row.details.uri}}</td>
        </template>
      </mu-data-table>
    </mu-col>
  </mu-row>
</template>

<script>
import axios from "axios";

import theme from '@/mixins/theme.js'

import chart from '@/components/Charts/Charts.vue'

export default {
  props: [],
  mixins: [theme],
  components: {
    chart
  },
  data() {
    return {
      realtimedata: [],
      apis: [],
      users: [],
      modelUserNow: 0,

      interval: null,

      currentPage: 1,
      itemsPerPage: 10,
      
      take: 10,
      loading: false,
    };
  },
  watch: {

  },
  computed: {
    line() {
      return {
        title: {
          text: this.$t('stat.user_realtime') + ': ' + this.modelUserNow,
          x: "center",
          align: "right",
          textStyle: {
              color: this.themeTextColor
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            animation: false
          }
        },
        xAxis: {
          type: "time",
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: this.themeTextColor
            }
          }
        },
        yAxis: {
          type: "value",
          boundaryGap: [0, "100%"],
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: this.themeTextColor
            }
          }
        },
        series: [
          {
            name: this.$t('stat.user_realtime'),
            type: "line",
            showSymbol: false,
            hoverAnimation: false,
            data: this.realtimedata,
            itemStyle: {
              normal: {
                color: this.themePrimaryColor
              }
            }
          }
        ],
      };
    },
    columns() {
      var array = [
        { title: this.$t('profile.username'), name: 'name' },
        { title: this.$t('profile.role'), name: 'role' },
        { title: this.$t('users.route'), name: 'route' },
        { title: this.$t('users.browser'), name: 'browser' },
      ];
      return array;
    },
    apisColumns() {
      var array = [
        { title: this.$t('pass.time'), name: 'time' },
        { title: this.$t('profile.username'), name: 'name' },
        { title: this.$t('api.method'), name: 'method' },
        { title: this.$t('users.route'), name: 'route' },
      ];
      return array;
    },
    
  },
  mounted() {
    this.getRealtime();
    this.update();
  },
  beforeDestroy() {
    window.clearInterval(this.interval);
  },
  methods: {
    getRealtime() {
      this.loading = true;
      axios
        .get(this.$store.getters.urlApi + "user/now?take=" + this.take, {
          headers: {
            token: this.$store.state.auth.token
          }
        })
        .then(response => {
          this.realtimedata.push([Date.now(), response.data.data.count]);
          this.modelUserNow = response.data.data.count;
          this.users = response.data.data.users;
          this.apis = response.data.data.apis.reverse();
          this.loading = false;
        });
    },
    getRealTimeE() {
      this.getRealtime();
    },
    update() {
      this.interval = setInterval(this.getRealTimeE, 10000);
    },
    stringRole(roles) {
      return roles.join(', ');
    },
    timestampToString(time) {
      var datetime = new Date();
      datetime.setTime(time * 1000);
      var year = datetime.getFullYear();
      var month = datetime.getMonth() + 1;
      var date = datetime.getDate();
      var hour = datetime.getHours();
      var minute = datetime.getMinutes();
      var second = datetime.getSeconds();
      return year + "-" + this.pad(month, 2) + "-" + this.pad(date, 2) + " " + this.pad(hour, 2) + ":" + this.pad(minute, 2) + ":" + this.pad(second, 2);
    },
    pad(n, width, z) {
      z = z || '0';
      n = n + '';
      return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    },
  }
};
</script>
